import MuiSkeleton, { type SkeletonProps } from '@mui/material/Skeleton';

export type { SkeletonProps };

const Skeleton = (props: SkeletonProps) => <MuiSkeleton {...props} />;

export default Skeleton;
